import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";

export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true, timeout: 20000 });

export function errorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return "Une erreur est survenue. Appelez-nous au 07 45 71 15 10.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return "Merci de vérifier les champs du formulaire.";
  return String(detail?.msg ?? detail);
}
